import React from 'react'
import CustomRow from '../../../reusable-components/CustomRow'
import { Button, Card, Col, Space, Table, Tooltip, theme } from 'antd'
import { useDispatch } from 'react-redux'
import coreReducer from '../../../../core/utils/reducer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faUsers } from '@fortawesome/free-solid-svg-icons'
import { hexToRGBA } from '../../../lib/utils'
import PlanTemplateForm from './PlanTemplateForm'

const TreatmentPlansList = ({ planTemplates, dataPoints, handleEnrollmentView, refreshView, isMonitoring }) => {
  const dispatch = useDispatch()
  const { token } = theme.useToken()
  const planType = 'treatment'
  const planLabel = 'Treatment Plans'

  const openPlanForm = (isNew, recordData) => {
    dispatch(
      coreReducer.actions.addTab({
        key: isNew ? 'TREATMENT_PLANS_new' : `TREATMENT_PLANS_${recordData._id}`,
        closable: true,
        label: 'New Treatment Plan',
        children: (
          <>
            <PlanTemplateForm
              isMonitoring={isMonitoring}
              isNew={isNew}
              recordData={recordData}
              dataPoints={dataPoints}
              refreshView={refreshView}
              planType={planType}
              planLabel={planLabel}
            />
          </>
        )
      })
    )
  }

  return (
    <CustomRow>
      <Col span={24}>
        <Card
          headStyle={{ background: hexToRGBA(token.colorPrimary, 0.2) }}
          title='Treatment Plans'
          size='small'
          extra={
            <Button
              onClick={() => {
                openPlanForm(true)
              }}
            >
              New
            </Button>
          }
        >
          <Table
            size='small'
            bordered
            dataSource={planTemplates}
            columns={[
              {
                title: 'Name',
                key: 'name',
                dataIndex: 'name'
              },
              {
                title: 'Actions',
                render: (record) => {
                  return (
                    <Space wrap>
                      <Tooltip title='Edit'>
                        <FontAwesomeIcon
                          fontSize={20}
                          size='lg'
                          id='edit-treatment-plan'
                          icon={faEdit}
                          onMouseOver={(e) => {
                            e.currentTarget.style.color = token.colorPrimary
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.color = '#ccc'
                          }}
                          style={{ color: '#ccc', transition: 'color 300ms ease' }}
                          onClick={(e) => {
                            e.stopPropagation()
                            openPlanForm(false, record)
                          }}
                        />
                      </Tooltip>
                      <Tooltip title='Enrollment'>
                        <FontAwesomeIcon
                          fontSize={20}
                          size='lg'
                          icon={faUsers}
                          onMouseOver={(e) => {
                            e.currentTarget.style.color = token.colorPrimary
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.color = '#ccc'
                          }}
                          style={{ color: '#ccc', transition: 'color 300ms ease' }}
                          onClick={(e) => {
                            e.stopPropagation()
                            handleEnrollmentView(record)
                          }}
                        />
                      </Tooltip>
                    </Space>
                  )
                }
              }
            ]}
          />
        </Card>
      </Col>
    </CustomRow>
  )
}

export default TreatmentPlansList
